// import {useNavigate} from "react-router";
// import {useEffect} from "react";
// import axios from "axios";
import OtherHeader from "../components/otherheader";
import user from "../assets/images/iconuserverify.svg";
//import US from "../assets/images/EU.svg";
//import NGN from "../assets/images/ngnnigeria.jpg";
//import EU from "../assets/images/usds.svg";

import US from "../assets/images/EU.svg";
import NGN from "../assets/images/ngnnigeria.jpg";
import EU from "../assets/images/usds.svg";
import GB from "../assets/images/GB.svg";

import documentIcon from "../assets/images/document-text.svg";
import loader from "../assets/images/load.svg";
import { useLocation, useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import empty from "../assets/images/emptyadmin.svg";
import axios from "axios";
import factoring from "../assets/images/factoring.svg";
import emptywoman from "../assets/images/emptywoamn.svg";
import dot from "../assets/images/dotss.svg";
import checkbox from "../assets/images/marksuccess.svg";
import rejectimg from "../assets/images/cancelsuccess.svg";
import { ProgressBar } from "react-loader-spinner";
import deactivae from "../assets/images/deactivate.svg";
import getFullCurrencyName from "../components/currencyFullName";
import currencyPairCheck from "../components/logoCurrency";
import AmountCheck from "../components/amountcheck";
import { useSelector } from "react-redux";
import DocumentUploaderViewer from "../components/DocumentUploaderViewer";
import { resolveAccountRouteState } from "../utils/routeStateResolvers";

const UserAccount = () => {
  // const [users, setuser] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const selectoruser = useSelector((state) => state.users);
  const { id } = useParams();
  const [resolvedState, setResolvedState] = useState(location.state || null);
  const state = resolvedState || location.state || {};

  const [tab, settab] = useState(localStorage.getItem("tab"));
  const [selectedstatusindex, setselectedstatusIndex] = useState(0);
  const [transaction, settransaction] = useState([]);
  const [selectedstatus, setselectedstatus] = useState();
  const [buyers, setBuyers] = useState([]);
  const [seller] = useState([]);
  const [success, setsucess] = useState(false);
  const [deletes, setdelete] = useState(false);
  const [businessstatus, setbusinessstatus] = useState(state.status);
  const [wallets, setwallet] = useState([]);
  const [selectedwalletindex, setselectedwalletindex] = useState(0);
  const [isDrop, setisDrop] = useState(false);
  const [allbusiness, setallbusiness] = useState([]);
  const [hideprogressbar, sethideprogressbar] = useState(false);
  const [hideprogressbar2, sethideprogressbar2] = useState(false);

  const [message, setmessage] = useState("");
  const [urladdress, setaddressurl] = useState("");
  //  console.log(selectoruser);
  const businessName = state?.name || allbusiness?.name || "";
  const businessUser = state?.user || allbusiness?.user || {};

  useEffect(() => {
    let isMounted = true;

    const hydrateRouteState = async () => {
      if (location.state?._id) {
        setResolvedState(location.state);
        return;
      }

      const nextState = await resolveAccountRouteState(id, location.state);
      if (isMounted && nextState) {
        setResolvedState(nextState);
        setbusinessstatus(nextState.status);
      }
    };

    hydrateRouteState();

    return () => {
      isMounted = false;
    };
  }, [id, location.state]);

  useEffect(() => {
    if (success) {
      var timeout = setTimeout(() => {
        setsucess(false);
        //window.location.reload();
      }, 3000);
    }
    return () => {
      clearTimeout(timeout);
    };
  });
  useEffect(() => {
    if (deletes) {
      var timeout = setTimeout(() => {
        setdelete(false);
      }, 3000);
    }
    return () => {
      clearTimeout(timeout);
    };
  });

  useEffect(() => {
    const getPartners = async () => {
      if (!state?._id) return;
      try {
        const response = await axios.get(`/v1/flex/users/${state._id}`, {
          headers: {
            "Content-Type": "application/json",
            "x-business-id": `${state._id}`, 
          },
        });
        setBuyers(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    // getPartners();
  }, [state?._id]);

  useEffect(() => {
    const getBusinessDetails = async () => {
      await axios
        .get(`/v1/admin/get-full-business-details/${id}`)
        .then((res) => {
          const business = res.data.data.business;
          setallbusiness(business);
          settransaction(res.data.data.transactions);
          setbusinessstatus(business.status);
          setwallet(res.data.data.wallets);
          setResolvedState((prev) => prev || business);
        })
        .catch((e) => {
          console.log(e);
        });
    };
    getBusinessDetails();
  }, [id]);

  const handleDocumentUpload = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append(type, file);

    try {
      const res = await axios.post(
        `/v1/admin/upload-business-documents/${state._id}?businessType=${state.type}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setsucess(true);
      setmessage(`Successfully uploaded ${type}`);

      const updated = await axios.get(`/v1/admin/get-full-business-details/${id}`);
      setallbusiness(updated.data.data.business);
    } catch (err) {
      console.error("Upload error:", err?.response?.data);
      setdelete(true);
      setmessage(err?.response?.data?.message || "Failed to upload document");
    }
  };

  //console.log(allbusiness);
  const verifyBusiness = async (value) => {
    sethideprogressbar(true);
    const data = {
      status: value,
    };
    await axios
      .put(`/v1/admin/changeBusinessStatus/${state._id}`, data)
      .then((res) => {
        //  console.log(res);
        axios.get(`/v1/admin/get-full-business-details/${id}`).then((resp) => {
          setbusinessstatus(resp.data.data.business?.status);
        });
        setsucess(true);
        setdelete(false);
        setmessage(res.data.message);
        sethideprogressbar(false);
      })
      .catch((e) => {
        console.log(e);
        setsucess(false);
        setdelete(true);
        setmessage(e.response.data.message);
        sethideprogressbar(false);
      });
  };
  const GenerateWallet = async (value) => {
    sethideprogressbar2(true);

    await //  console.log(res);
      axios
        .post(`/v1/admin/wallet/open-wallet`, {
          currency: "NGN",
          businessId: state._id,
        })
        .then((resp) => {
          //  console.log(resp);
          //  console.log(resp.data.message);
          setsucess(true);
          setdelete(false);
          setmessage(resp.data.message);
          sethideprogressbar2(false);
          window.scrollTo(0, 0);
          //setbusinessstatus(resp.data.data.business?.status);
        })

        .catch((e) => {
          //  console.log(e);
          setsucess(false);
          setdelete(true);
          setmessage(e?.message ? e.message : e.response.data.message);
          sethideprogressbar(false);
          window.scrollTo(0, 0);
        });
  };
  const deleteBusiness = async (value) => {
    sethideprogressbar(true);

    await axios
      .delete(`/v1/admin/delete-business/${state._id}`)
      .then((res) => {
        //  console.log(res);
        navigate("/account");

        setsucess(true);
        setdelete(false);
        setmessage(res.data.message);
        sethideprogressbar(false);
      })
      .catch((e) => {
        // console.log(e);
        setsucess(false);
        setdelete(true);
        setmessage(e.response.data.message);
        sethideprogressbar(false);
      });
  };
  useEffect(() => {
    const getMapdetails = async () => {
      const data = {
        placeId: allbusiness.placeId,
      };
      axios
        .post(`/v1/utility/get-place-detail`, data)
        .then((res) => {
          setaddressurl(res.data.data.result.url);
        })
        .catch((e) => {
          console.log(e);
        });
    };
    if(allbusiness.placeId) getMapdetails();
  });

  const deactiveAccount = async () => {
    sethideprogressbar(true);
    const data = {
      status: "DEACTIVATE",
    };
    await axios
      .put(`/v1/admin/changeBusinessStatus/${state._id}`, data)
      .then((res) => {
        // console.log(res);
        setsucess(true);
        setdelete(false);
        setmessage(res.data.message);
        sethideprogressbar(false);
      })
      .catch((e) => {
        // console.log(e);
        setsucess(false);
        setdelete(true);
        setmessage(e.response.data.message);
        sethideprogressbar(false);
      });
  };
  const filtertransaction = transaction.filter((countrycodelists) =>
    countrycodelists.status.match(selectedstatus)
  );
  const trasnactionstatus = ["", "pending", "success", "declined"];

  return (
    <>
      <div
        style={{
          position: "relative",
        }}
      >
        <OtherHeader title={"BACK TO ACCOUNTS"} arrow={"keyboard_backspace"} />

        <div className="info-cl">
          <div className="overview">
            <h4
              style={{
                margin: "0px",
                padding: "0px",
              }}
            >
              Account Details
            </h4>
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "30px",
            }}
          >
            <div
              className="main-info-con-rights"
              style={{
                padding: "0px",
                minHeight: "100%",
                position: "relative",
              }}
            >
              {success && (
                <div
                  className="success"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <div className="lg-success">
                    <div className="ech-lg-hm">
                      <div className="main-sucees">Success</div>
                      <span
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {message}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {deletes && (
                <div
                  className="success"
                  style={{
                    background: "#FCFCFD",
                    border: " 1px solid #D0D5DD",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <div className="lg-success">
                    <div
                      className="ech-lg-hm"
                      style={{
                        background: "#F9FAFB",
                      }}
                    >
                      <div
                        className="main-sucees"
                        style={{
                          color: "#344054",
                        }}
                      >
                        Failed
                      </div>
                      <span
                        style={{
                          color: "#344054",
                        }}
                      >
                        {message}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className="top_head_cl" style={{ padding: "24px" }}>
                <div className="ip_v_lg">
                  <div
                    className="profile-d-icon"
                    style={{
                      height: "48px",
                      width: "48px",
                    }}
                  >
                    {businessName.slice(0, 2)}
                  </div>
                  <div className="name-avater-tag" style={{ gap: "8px" }}>
                    <span
                      style={{
                        color: "#101828",
                        fontWeight: "600",
                        fontSize: "20px",
                        lineHeight: "24px",
                        maxWidth: "200px",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {businessName}{" "}
                    </span>
                    <span className="business_name">
                      {businessUser?.firstName} {businessUser?.lastName}
                    </span>
                  </div>
                </div>
                <div
                  className="status_user"
                  style={{
                    color: businessstatus === "APPROVED" && "#12B76A",
                  }}
                >
                  {businessstatus}
                </div>
              </div>
              {businessstatus === "DEACTIVATE" && (
                <div
                  className="verify_account"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  <div
                    className="user_verify"
                    style={{
                      //  minWidth: "300px",
                      cursor: "pointer",
                    }}
                    onClick={() => verifyBusiness("APPROVED")}
                  >
                    <img src={user} alt="" />
                    ACTIVATE
                  </div>
                  {selectoruser?.email === "philip@tradevu.co" || selectoruser?.email === "habeeb@tradevu.co" && (
                    <div
                      className="user_verify"
                      style={{
                        minWidth: "300px",
                        cursor: "pointer",
                        color: "#F04438",
                      }}
                      onClick={() => deleteBusiness()}
                    >
                      <img src={deactivae} alt="" />
                      Delete Business
                    </div>
                  )}
                  {hideprogressbar && (
                    <ProgressBar
                      height="40"
                      width=""
                      ariaLabel="progress-bar-loading"
                      wrapperClass="progress-bar-wrapper"
                      borderColor="#6f00ff"
                      barColor="#6f00ff"
                    />
                  )}
                </div>
              )}

              {businessstatus === "PENDING" && (selectoruser?.email === "philip@tradevu.co" || selectoruser?.email === "habeeb@tradevu.co") && (
                <div
                  className="verify_account"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  {(selectoruser?.email === "philip@tradevu.co" || selectoruser?.email === "habeeb@tradevu.co") && (
                    <div
                      className="user_verify"
                      style={{
                        minWidth: "300px",
                        cursor: "pointer",
                        color: "#F04438",
                      }}
                      onClick={() => deleteBusiness()}
                    >
                      <img src={deactivae} alt="" />
                      Delete Business
                    </div>
                  )}
                  {hideprogressbar && (
                    <ProgressBar
                      height="40"
                      width=""
                      ariaLabel="progress-bar-loading"
                      wrapperClass="progress-bar-wrapper"
                      borderColor="#6f00ff"
                      barColor="#6f00ff"
                    />
                  )}
                </div>
              )}
              {(businessstatus === "SUBMITTED") && (
                <div
                  className="verify_account"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "32px",
                  }}
                >
                  {businessstatus === "SUBMITTED" && (
                    <div
                      className="user_verify"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        verifyBusiness("PROCESSING");
                      }}
                    >
                      <img src={user} alt="" />
                      Start Verifivication
                    </div>
                  )}
                  {(selectoruser?.email === "philip@tradevu.co" || selectoruser?.email === "habeeb@tradevu.co") && (
                    <div
                      className="user_verify"
                      style={{
                        // minWidth: "300px",
                        cursor: "pointer",
                        color: "#F04438",
                      }}
                      onClick={() => deleteBusiness()}
                    >
                      <img src={deactivae} alt="" />
                      Delete Business
                    </div>
                  )}
                  {hideprogressbar && (
                    <ProgressBar
                      height="40"
                      width=""
                      ariaLabel="progress-bar-loading"
                      wrapperClass="progress-bar-wrapper"
                      borderColor="#6f00ff"
                      barColor="#6f00ff"
                    />
                  )}
                </div>
              )}
              {businessstatus === "PROCESSING" && (
                <div
                  className="verify_account"
                  style={{
                    display: "flex",
                    gap: "16px",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="user_verify"
                    style={{
                      // minWidth: "300px",
                      cursor: "pointer",
                    }}
                    onClick={() => verifyBusiness("APPROVED")}
                  >
                    <img src={user} alt="" />
                    Activate account
                  </div>
                  {(selectoruser?.email === "philip@tradevu.co" || selectoruser?.email === "habeeb@tradevu.co") && (
                    <div
                      className="user_verify"
                      style={{
                        // minWidth: "300px",
                        cursor: "pointer",
                        color: "#F04438",
                      }}
                      onClick={() => deleteBusiness()}
                    >
                      <img src={deactivae} alt="" />
                      Delete Business
                    </div>
                  )}

                  {hideprogressbar && (
                    <ProgressBar
                      height="40"
                      width=""
                      ariaLabel="progress-bar-loading"
                      wrapperClass="progress-bar-wrapper"
                      borderColor="#6f00ff"
                      barColor="#6f00ff"
                    />
                  )}
                </div>
              )}

              {businessstatus === "APPROVED" && (
                <div
                  className="verify_account"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    className="user_verify"
                    style={{
                      minWidth: "300px",
                      cursor: "pointer",
                      color: "#F04438",
                    }}
                    onClick={() => verifyBusiness("DEACTIVATE")}
                  >
                    <img src={deactivae} alt="" />
                    Deactive account
                  </div>
                  {hideprogressbar && (
                    <ProgressBar
                      height="40"
                      width=""
                      ariaLabel="progress-bar-loading"
                      wrapperClass="progress-bar-wrapper"
                      borderColor="#6f00ff"
                      barColor="#6f00ff"
                    />
                  )}
                </div>
              )}

              <div className="user_balance">
                <div className="main_user_dash">
                  <div className="top-c_tp">
                    <div
                      className="wallet_balance"
                      style={{
                        fontWeight: "600",
                      }}
                    >
                      Wallet balance
                    </div>
                    <div
                      className="wallet_drop "
                      style={{
                        position: "relative",
                      }}
                      onClick={() => setisDrop(!isDrop)}
                    >
                      <div className="img_currency">
                        <img
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                          src={
                            wallets[selectedwalletindex]?.currency === "NGN"
                              ? NGN
                              : wallets[selectedwalletindex]?.currency === "GBP"
                                ? GB
                                : wallets[selectedwalletindex]?.currency === "EUR"
                                  ? EU
                                  : US
                          }
                          alt=""
                        />
                        <div className="each_drop_wallet">
                          {wallets[selectedwalletindex]?.currency}{" "}
                          {getFullCurrencyName(wallets[selectedwalletindex]?.currency)}
                          <span className="material-icons"> keyboard_arrow_down</span>
                        </div>
                      </div>
                      {isDrop && (
                        <div className="drop-absolute-icon">
                          {wallets?.map((res, index) => (
                            <div
                              className="img-avater-icon-balanc"
                              key={index}
                              style={{
                                fontWeight: "600",
                              }}
                              onClick={() => setselectedwalletindex(index)}
                            >
                              <img
                                style={{
                                  width: "25px",
                                  height: "25px",
                                }}
                                src={
                                  res.currency === "EUR"
                                    ? EU
                                    : res.currency === "NGN"
                                      ? NGN
                                      : res.currency === "USD"
                                        ? US
                                        : GB
                                }
                                alt=""
                              />
                              {res.currency} {currencyPairCheck(res.currency)}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <h2 className="balance_it_w">
                    {currencyPairCheck(wallets[selectedwalletindex]?.currency)}
                    {AmountCheck(wallets[selectedwalletindex]?.balance)}
                  </h2>
                </div>
              </div>
              <div style={{ marginTop: "-20px" }} className="details-d_tl">
                <div className="md-details-col">
                  <div className="details_cl_tl">Details</div>
                  <div
                    className="each_details_tl"
                    style={{
                      borderBottom: "1px solid #E7E9FB",
                      paddingBottom: "30px",
                    }}
                  >
                    <div className="each_main_tl">
                      <div className="each_d_lt">Business name</div>
                      <span className="d-lt-a">{state?.name}</span>
                    </div>
                    <div className="each_main_tl">
                      <div className="each_d_lt">Business type</div>
                      <span className="d-lt-a">{allbusiness.type}</span>
                    </div>

                    <div className="each_main_tl">
                      <div className="each_d_lt">Address</div>
                      <div
                        className="d-lt-a"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        {state.address}
                        <a href={`${urladdress}`} target="_bkank" rel="noreferrer">
                          <span
                            className="material-icons"
                            style={{
                              cursor: "pointer",
                              color: "#6f00ff",
                            }}
                          >
                            travel_explore
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="each_details_tl" style={{ paddingBottom: "30px" }}>
                    <div className="each_main_tl">
                      <div className="each_d_lt">Account owner</div>
                      <span className="d-lt-a">
                        {state?.user?.firstName} {state?.user?.lastName}{" "}
                      </span>
                    </div>
                    <div className="each_main_tl">
                      <div className="each_d_lt">Email address</div>
                      <span className="d-lt-a">{state?.user?.email}</span>
                    </div>

                    <div className="each_main_tl">
                      <div className="each_d_lt">Phone number</div>
                      <span className="d-lt-a">{state?.user?.phoneNumber} </span>
                    </div>
                    {businessstatus === "APPROVED" && (
                      <div
                        className="verify_account"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className="user_verify"
                          style={{
                            cursor: "pointer",
                            color: "#F04438",

                            display: "flex",
                            borderRadius: "4px",
                            fontWeight: "600",
                            color: "rgb(111, 0, 255)",
                            textAlign: "left",
                            paddingLeft: "0px",
                          }}
                          onClick={() => GenerateWallet("DEACTIVATE")}
                        >
                          Generate wallet
                        </div>
                        {hideprogressbar2 && (
                          <ProgressBar
                            height="40"
                            width="100px"
                            ariaLabel="progress-bar-loading"
                            wrapperClass="progress-bar-wrapper"
                            borderColor="#6f00ff"
                            barColor="#6f00ff"
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-right-col-cf">
              <ul className="tp-head-list">
                <li
                  onClick={() => {
                    localStorage.setItem("tab", "transaction");
                    settab("transaction");
                  }}
                  style={{
                    borderBottom: tab === "transaction" ? "3px solid #6F00FF" : "",
                  }}
                >
                  Transactions
                </li>
                <li
                  onClick={() => {
                    localStorage.setItem("tab", "buyers");

                    settab("buyers");
                  }}
                  style={{
                    borderBottom: tab === "buyers" ? "3px solid #6F00FF" : "",
                  }}
                >
                  Partners
                </li>
                {/**
                <li
                  onClick={() => {
                    localStorage.setItem("tab", "seller");

                    settab("seller");
                  }}
                  style={{
                    borderBottom: tab === "seller" ? "3px solid #6F00FF" : "",
                  }}
                >
                  Sellers
                </li>
                */}
                <li
                  onClick={() => {
                    localStorage.setItem("tab", "kyc");
                    settab("kyc");
                  }}
                  style={{
                    borderBottom: tab === "kyc" ? "3px solid #6F00FF" : "",
                  }}
                >
                  KYC
                </li>
              </ul>
              <div className="main_tp_lig">
                {tab === "kyc" && (
                  <>
                    <div className="each_top_lt">
                      <div className="left-ttl-c">
                        <span className="typ_lg_vg">Country of Registration</span>
                        <span className="an-fg-lg">{state.country}</span>
                      </div>
                      <div className="left-ttl-c">
                        <span className="typ_lg_vg">RC Number</span>
                        <span className="an-fg-lg">{state.registrationNumber}</span>
                      </div>
                    </div>
                    {state?.TIN && (
                      <div className="each_top_lt">
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">Tax Indentifaiction Number(TIN)</span>
                          <span className="an-fg-lg">{state.TIN}</span>
                        </div>
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">VAT Number</span>
                          <span className="an-fg-lg">{state.VAT}</span>
                        </div>
                      </div>
                    )}
                    {state?.legalName && (
                      <div className="each_top_lt">
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">Legal Name</span>
                          <span className="an-fg-lg">{state.legalName}</span>
                        </div>
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">Category</span>
                          <span className="an-fg-lg">{state.VAT}</span>
                        </div>
                      </div>
                    )}
                    {state.country === "Nigeria" && (
                      <div
                        className="prof_ad_rf"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (allbusiness.proofOfAddress) {
                            navigate("/proof_of_address", {
                              state: {
                                image: allbusiness?.proofOfAddress?.url,
                                type: allbusiness?.proofOfAddress?.type,
                                id: state._id,
                              },
                            });
                          }
                        }}
                      >
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">Proof of address</span>
                          <span className="an-fg-lg">{allbusiness?.proofOfAddress?.type}</span>
                        </div>

                        <div className="each_sec_lg_vg">
                          <div className="lg-md-lf-glv">
                            <img src={documentIcon} alt="" />
                            Proof of address
                          </div>
                          {allbusiness.proofOfAddress ? (
                            <span className="material-icons">navigate_next</span>
                          ) : (
                            "Not uploaded"
                          )}

                          <div className="loader">
                            <img
                              src={
                                allbusiness?.proofOfAddress?.status === "APPROVED"
                                  ? checkbox
                                  : allbusiness?.proofOfAddress?.status === "REJECTED"
                                    ? rejectimg
                                    : loader
                              }
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {state.country !== "Nigeria" && (
                      <div className="prof_ad_rf">
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">Directors </span>
                        </div>
                        {allbusiness.directors &&
                          allbusiness.directors?.map((res, index) => (
                            <div
                              className="each_sec_lg_vg"
                              style={{
                                border: "1px solid #e7e9fb",
                              }}
                              key={index}
                              onClick={() => {
                                if (res?.meansOfIdentification) {
                                  navigate("/verifyDocument", {
                                    state: {
                                      documents: res,
                                      image: res?.idDocument?.url,
                                      type: res?.meansOfIdentification,
                                      id: state._id,
                                      businessType: allbusiness?.type,
                                    },
                                  });
                                }
                              }}
                            >
                              <div className="lg-md-lf-glv">
                                <img src={documentIcon} alt="" />
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <h4
                                    style={{
                                      padding: "0px",
                                      margin: "0px",
                                    }}
                                    className="mydirectorsname"
                                  >
                                    {res?.firstName} {res?.lastName}
                                  </h4>
                                  <span className=" smallbusiness">{res?.dateOfBirth}</span>
                                </div>
                              </div>
                              <span className="mydirectorsname"> {res.meansOfIdentification}</span>{" "}
                              <div className="loader">
                                <img src={loader} alt="" />
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                    {state.country !== "Nigeria" && (
                      <div className="prof_ad_rf">
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">Shareholders </span>
                        </div>
                        {allbusiness.shareHolders &&
                          allbusiness.shareHolders?.map((res, index) => (
                            <div
                              className="each_sec_lg_vg"
                              style={{
                                border: "1px solid #e7e9fb",
                              }}
                              key={index}
                              onClick={() => {
                                if (res?.meansOfIdentification) {
                                  navigate("/verifyDocument", {
                                    state: {
                                      documents: res,

                                      image: res?.idDocument?.url,
                                      type: res?.meansOfIdentification,
                                      id: state._id,
                                      businessType: allbusiness?.type,
                                    },
                                  });
                                }
                              }}
                            >
                              <div className="lg-md-lf-glv">
                                <img src={documentIcon} alt="" />
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <h4
                                    style={{
                                      padding: "0px",
                                      margin: "0px",
                                    }}
                                    className="mydirectorsname"
                                  >
                                    {res?.firstName} {res?.lastName}
                                  </h4>
                                  <span className=" smallbusiness">{res?.dateOfBirth}</span>
                                </div>
                              </div>
                              <span className="mydirectorsname"> {res.meansOfIdentification}</span>
                              <div className="loader">
                                <img src={loader} alt="" />
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                    {state.country === "Nigeria" && (
                      <div className="prof_ad_rf">
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">General documents</span>
                        </div>

                        <DocumentUploaderViewer
                          label="Certificate of Incorporation"
                          id="upload-cac"
                          documentKey="CERTIFICATE_OF_INCORPORATION"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={allbusiness?.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="CAC Status Report (Optional)"
                          id="upload-cac-status-report"
                          documentKey="CAC_STATUS_REPORT"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={allbusiness?.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="Valid means of ID"
                          id="upload-valid-id"
                          documentKey="VALID_ID"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={allbusiness?.type}
                          onUpload={handleDocumentUpload}
                          containerStyle={{
                            borderTopLeftRadius: "0px",
                            borderTopRightRadius: "0px",
                            marginTop: "-18px",
                          }}
                        />
                      </div>
                    )}
                    {state.type === "LLC" && state.country === "Nigeria" && (
                      <div className="prof_ad_rf" style={{}}>
                        <div className="left-ttl-c">
                          <span className="typ_lg_vg">{state.type} documents</span>
                        </div>
                        <DocumentUploaderViewer
                          label="CAC Form 2 (Optional)"
                          id="upload-cac-form-2"
                          documentKey="CAC_FORM_2"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={allbusiness?.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="CAC Form 2.1 (Optional)"
                          id="upload-cac-form-2-1"
                          documentKey="CAC_FORM_2_1"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={state.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="CAC Form 3 (Optional)"
                          id="upload-cac-form-3"
                          documentKey="CAC_FORM_3"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={state.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="CAC Form 4 (Optional)"
                          id="upload-cac-form-4"
                          documentKey="CAC_FORM_4"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={state.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="CAC FORM 7"
                          id="upload-cac-form-7"
                          documentKey="CAC_FORM_7"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={allbusiness.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="Memorandum & articles of association"
                          id="upload-memo-article"
                          documentKey="MEMORANDUM_AND_ARTICLE_OF_ASSOCIATION"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={allbusiness.type}
                          onUpload={handleDocumentUpload}
                        />

                        <DocumentUploaderViewer
                          label="Board resolution to open an account with Tradevu"
                          id="upload-board-resolution"
                          documentKey="BOARD_RESOLUTION"
                          documentGroup={allbusiness}
                          businessId={state._id}
                          businessType={allbusiness.type}
                          onUpload={handleDocumentUpload}
                        />

                        {allbusiness?.directors?.length > 0 && (
                          <span
                            className="typ_lg_vg"
                            style={{
                              marginBottom: "18px",
                            }}
                          >
                            BVN of the Directors of the Company
                          </span>
                        )}

                        {allbusiness?.directors?.length > 0 &&
                          allbusiness?.directors?.map((item, index) => (
                            <div
                              className="each_sec_lg_vg"
                              style={{
                                border: "1px solid #e7e9fb",
                                borderTop: "1px solid #e7e9fb",
                                marginTop: "-18px",
                              }}
                              key={index}
                            >
                              <div className="lg-md-lf-glv">
                                <img src={documentIcon} alt="" />

                                <div
                                  style={{
                                    display: "flex",
                                    gap: "16px",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "4px",
                                    }}
                                  >
                                    <span>First name</span>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item?.firstName}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "4px",
                                    }}
                                  >
                                    <span>Last name</span>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item?.lastName}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "4px",
                                    }}
                                  >
                                    <span>Phone number</span>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item?.phoneNumber ? item?.phoneNumber : "Not Added"}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <span
                                className="material-iconss"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <div>BVN Number</div>
                                <span
                                  style={{
                                    fontWeight: "600",
                                  }}
                                >
                                  {item?.bvnNumber}
                                </span>
                              </span>
                              <div
                                className="loader"
                                style={{
                                  top: "30px",
                                }}
                              >
                                <img
                                  title={item._id ? "Verified" : "Not-Verified"}
                                  src={item._id ? checkbox : loader}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  alt=""
                                />
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                    {state.type === "SoleProprietorship" && state.country === "Nigeria" && (
                      <>
                        <div className="prof_ad_rf" style={{}}>
                          <div className="left-ttl-c">
                            <span className="typ_lg_vg">{state.type} documents</span>
                          </div>
                          <DocumentUploaderViewer
                            label="CAC BIN FORM (Optional)"
                            id="upload-cac-bin"
                            documentKey="CAC_FORM_1"
                            documentGroup={allbusiness}
                            businessId={state._id}
                            businessType={allbusiness.type}
                            onUpload={handleDocumentUpload}
                          />

                          <DocumentUploaderViewer
                            label="APPLICATION LETTER"
                            id="upload-application-letter"
                            documentKey="APPLICATION_LETTER"
                            documentGroup={allbusiness}
                            businessId={state._id}
                            businessType={allbusiness.type}
                            onUpload={handleDocumentUpload}
                          />
                        </div>
                        <div className="prof_ad_rf">
                          <div
                            className="left-ttl-c"
                            style={{
                              marginBottom: "18px",
                            }}
                          >
                            <span className="typ_lg_vg">BVN OF DIRECTORS</span>
                          </div>
                          {allbusiness?.directors &&
                            allbusiness?.directors.map((item, index) => (
                              <div
                                className="each_sec_lg_vg"
                                style={{
                                  border: "1px solid #e7e9fb",
                                  borderTop: "1px solid #e7e9fb",
                                  marginTop: "-18px",
                                }}
                                key={index}
                              >
                                <div className="lg-md-lf-glv">
                                  <img src={document} alt="" />

                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "16px",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "4px",
                                      }}
                                    >
                                      <span>First name</span>
                                      <div
                                        style={{
                                          fontWeight: "600",
                                        }}
                                      >
                                        {item?.firstName}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "4px",
                                      }}
                                    >
                                      <span>Last name</span>
                                      <div
                                        style={{
                                          fontWeight: "600",
                                        }}
                                      >
                                        {item?.lastName}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "4px",
                                      }}
                                    >
                                      <span>Phone number</span>
                                      <div
                                        style={{
                                          fontWeight: "600",
                                        }}
                                      >
                                        {item?.phoneNumber ? item?.phoneNumber : "Not Added"}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <span
                                  className="material-iconss"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                  }}
                                >
                                  <div>BVN Number</div>
                                  <span
                                    style={{
                                      fontWeight: "600",
                                    }}
                                  >
                                    {item?.bvnNumber}
                                  </span>
                                </span>
                                <div
                                  className="loader"
                                  style={{
                                    top: "30px",
                                  }}
                                >
                                  <img
                                    title={item._id ? "Verified" : "Not-Verified"}
                                    src={item._id ? checkbox : loader}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    alt=""
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      </>
                    )}
                  </>
                )}
                {tab === "transaction" && (
                  <>
                    <div className="section_modl_lg">
                      {trasnactionstatus &&
                        trasnactionstatus?.map((statuss, index) => (
                          <div
                            className="each_section"
                            onClick={() => {
                              setselectedstatusIndex(index);
                              setselectedstatus(statuss);
                            }}
                            style={{
                              background: selectedstatusindex === index ? "#EBE4FF" : "",
                              color: selectedstatusindex === index ? "#6F00FF" : "#667085",
                              padding:
                                selectedstatusindex === index
                                  ? "8px 16px 8px 16px"
                                  : "8px 8px 8px 8px",
                            }}
                            key={index}
                          >
                            {statuss === ""
                              ? "All"
                              : statuss === "pending"
                                ? "Pending"
                                : statuss === "success"
                                  ? "Completed"
                                  : "Declined"}{" "}
                          </div>
                        ))}{" "}
                    </div>
                    {filtertransaction.length === 0 && (
                      <div className="emtty_transact">
                        <img src={empty} alt="" />
                        <div className="empty_info">
                          <h4>No transactions yet</h4>
                          <div>This account has no recent transactions.</div>
                        </div>
                      </div>
                    )}
                    {filtertransaction.length >= 1 &&
                      transaction?.map((res, index) => (
                        <div className="main-lg-request" key={index}>
                          <div className="each-request">
                            <div className="img-name">
                              <img src={factoring} alt="" />
                              <div
                                className="mytag-lg"
                                style={{
                                  gap: "0px",
                                }}
                              >
                                <div className="head-tg">
                                  {res?.name
                                    ? res.name
                                    : res.accountName
                                      ? res.accountName
                                      : res.narration}
                                </div>
                                <span
                                  className="small-tg"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {res.TransactionType}
                                  <span
                                    className={"status_p"}
                                    style={{
                                      color:
                                        res?.status === "Success"
                                          ? "green"
                                          : res?.status === "Pending"
                                            ? "#f79009"
                                            : "crimson",
                                    }}
                                  >
                                    <img src={dot} alt="" /> {res?.status}
                                  </span>
                                </span>
                              </div>
                            </div>
                            <div className="mytag-lg">
                              <div
                                className="head-tg"
                                style={{
                                  color: "#344054",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  lineHeight: "19.6px",
                                  textAlign: "right",
                                }}
                              >
                                {currencyPairCheck(res.currency)}
                                {parseFloat(res.amount).toLocaleString()}{" "}
                              </div>
                              <span className="small-tg" style={{ textAlign: "right" }}>
                                {new Date(res.createdAt).toDateString()}{" "}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}{" "}
                  </>
                )}
                {tab === "buyers" && (
                  <>
                    {" "}
                    {buyers.length === 0 && (
                      <div className="emtty_transact">
                        <img src={emptywoman} alt="" />
                        <div className="empty_info" style={{ maxWidth: "311px" }}>
                          <h4>Account doesn’t have any partner yet</h4>
                          <div>
                            You’ll see partners that this account has added to their business here.
                          </div>
                        </div>
                      </div>
                    )}
                    {buyers.length >= 1 &&
                      buyers?.map((res, index) => (
                        <div className="main-lg-request" key={index}>
                          <div className="each-request">
                            <div className="img-name">
                              <div
                                className="profile-d-icon"
                                style={{
                                  height: "48px",
                                  width: "48px",
                                }}
                              >
                                {state._id === res?.business?._id
                                  ? res.businessName?.slice(0, 2)
                                  : res.business.name?.slice(0, 2)}
                              </div>

                              <div className="mytag-lg">
                                <div className="head-tg">
                                  {state._id === res?.business?._id
                                    ? res.businessName
                                    : res.business.name}
                                </div>
                                <span
                                  className="small-tg"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {res?.email}
                                </span>
                              </div>
                            </div>
                            <div className="mytag-lg">
                              <div
                                className="head-tg"
                                style={{
                                  color: "#667085",

                                  fontSize: "14px",
                                  fontWeight: "600",
                                  lineHeight: "19.6px",
                                  textAlign: "right",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                  //  textTransform: "capitalize",
                                }}
                              >
                                <span
                                  className={"status_p"}
                                  style={{
                                    color:
                                      res?.status === "ACTIVE"
                                        ? "green"
                                        : res.status === "Pending"
                                          ? "#f79009"
                                          : "crimson",
                                    textAlign: "right",
                                  }}
                                >
                                  {res?.status}
                                </span>
                                {res.orders.length} order(s)
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}{" "}
                  </>
                )}
                {tab === "seller" && (
                  <>
                    {" "}
                    {seller.length === 0 && (
                      <div className="emtty_transact">
                        <img src={emptywoman} alt="" />
                        <div className="empty_info" style={{ maxWidth: "311px" }}>
                          <h4>Account doesn’t have any seller yet</h4>
                          <div>
                            You’ll see sellers that this account has added to their business here.
                          </div>
                        </div>
                      </div>
                    )}
                    {seller.length >= 1 &&
                      seller?.map((res, index) => (
                        <div className="main-lg-request" key={index}>
                          <div className="each-request">
                            <div className="img-name">
                              <img src={factoring} alt="" />
                              <div className="mytag-lg">
                                <div className="head-tg">{res.business.name}</div>
                                <span
                                  className="small-tg"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {res.TransactionType}
                                  <span
                                    className={"status_p"}
                                    style={{
                                      color:
                                        res.status === "success"
                                          ? "green"
                                          : res.status === "Pending"
                                            ? "#f79009"
                                            : "crimson",
                                    }}
                                  >
                                    <img src={dot} alt="" /> {res.status}
                                  </span>
                                </span>
                              </div>
                            </div>
                            <div className="mytag-lg">
                              <div
                                className="head-tg"
                                style={{
                                  color: "#667085",

                                  fontSize: "14px",
                                  fontWeight: "600",
                                  lineHeight: "19.6px",
                                  textAlign: "right",
                                  textTransform: "capitalize",
                                }}
                              >
                                3 orders
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}{" "}
                  </>
                )}{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserAccount;
